import qs from 'qs';

const algoliaUrlToSearchState = ({ search }: Location) =>
  qs.parse(search.slice(1));

export default algoliaUrlToSearchState;
